<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <!-- <div class="settings-header">
            Worksheet
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div> -->
          <div class="nav-tree" style="margin-bottom: 20px; display: flex; align-items: flex-end;">
            <el-date-picker
              ref="datepicker"
              popper-class="custom-date-picker"
              size="mini"
              v-model="period"
              style="margin-right: 10px;"
              prefix-icon="el-icon-date"
              type="daterange"
              align="center"
              format="d MMM yy"
              value-format="timestamp"
              range-separator=""
              start-placeholder="Start date"
              end-placeholder="End date"
              @change="loadList()"
              :clearable="false"
              :picker-options="pickerOptions">
            </el-date-picker>
            <el-dropdown size="mini" style="margin-left: 10px">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 7)">PDF</el-dropdown-item>
                <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 7)">XL
                </el-dropdown-item>
                <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,7)">Email</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <el-table
            height="calc(100vh - 158px)"
            size="mini"
            :data="tableData"
            :summary-method="getSummaries"
            show-summary
            ref="table"
            sum-text="Total"
            :empty-text="$t('general_noData')"
            @cell-click="cellClick">
            <el-table-column
              fixed
              prop="accountcode"
              label="DB Code"
              width="100">
            </el-table-column>
            <el-table-column
              fixed
              prop="accountnumber"
              label="Acc. No."
              width="100">
            </el-table-column>
            <el-table-column
              fixed
              prop="account"
              label="Accounts List (COA)"
              width="240"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <div style="cursor: pointer; color: #409EFF;">
                  {{scope.row.account}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Unadjusted Trial Balance" header-align="center">
              <el-table-column
                prop="unadjdebit"
                label="Debit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.unadjdebit ? formatPrice(scope.row.unadjdebit) : null}}
                </template>
              </el-table-column>
              <el-table-column
                prop="unadjcredit"
                label="Credit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.unadjcredit ? formatPrice(scope.row.unadjcredit) : null}}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Adjusting Journal Entries" header-align="center">
              <el-table-column
                prop="adjdebit"
                label="Debit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.adjdebit ? formatPrice(scope.row.adjdebit) : null}}
                </template>
              </el-table-column>
              <el-table-column
                prop="adjcredit"
                label="Credit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.adjcredit ? formatPrice(scope.row.adjcredit) : null}}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Adjusted Trial Balance" header-align="center">
              <el-table-column
                prop="adjtbdebit"
                label="Debit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.adjtbdebit ? formatPrice(scope.row.adjtbdebit) : null}}
                </template>
              </el-table-column>
              <el-table-column
                prop="adjtbcredit"
                label="Credit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.adjtbcredit ? formatPrice(scope.row.adjtbcredit) : null}}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Income Statement" header-align="center">
              <el-table-column
                prop="isdebit"
                label="Debit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.isdebit ? formatPrice(scope.row.isdebit) : null}}
                </template>
              </el-table-column>
              <el-table-column
                prop="iscredit"
                label="Credit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.iscredit ? formatPrice(scope.row.iscredit) : null}}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Closing Entries" header-align="center">
              <el-table-column
                prop="closingdebit"
                label="Debit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.closingdebit ? formatPrice(scope.row.closingdebit) : null}}
                </template>
              </el-table-column>
              <el-table-column
                prop="closingcredit"
                label="Credit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.closingcredit ? formatPrice(scope.row.closingcredit) : null}}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Post Closing Trial Balance" header-align="center">
              <el-table-column
                prop="posttbdebit"
                label="Debit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.posttbdebit ? formatPrice(scope.row.posttbdebit) : null}}
                </template>
              </el-table-column>
              <el-table-column
                prop="posttbcredit"
                label="Credit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.posttbcredit ? formatPrice(scope.row.posttbcredit) : null}}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Balance Sheet" header-align="center">
              <el-table-column
                prop="bsdebit"
                label="Debit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.bsdebit ? formatPrice(scope.row.bsdebit) : null}}
                </template>
              </el-table-column>
              <el-table-column
                prop="bscredit"
                label="Credit"
                header-align="center"
                align="right"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.bscredit ? formatPrice(scope.row.bscredit) : null}}
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>
  <generall-edger-detailed-modal
      :startDate="period[0]"
      :endDate="period[1]"
      :currencyList="currencyList"
      ref="generallLedgerDetailedModal"
  />
  </div>
</template>

<script>
import axios from 'axios'
let moment = require('moment');
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import GenerallEdgerDetailedModal from "../components/settings/settingsGlAccounts2/GenerallLedgerDetailedModal";

export default {
  name: 'worksheet',
  components: {
    GenerallEdgerDetailedModal,
    SweetModal,
  },
  created() {
    this.period.push(moment().startOf('year'))
    this.period.push(moment().startOf('day'))
    this.loadList()
  },
  watch: {
    'form.period'(val) {
      if (!val) {
        this.form.days = 0
      }
    },
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
    financialYearStartDateFormatted () {
      return this.companyLayout && this.companyLayout.financialYearStartDate ? moment(this.companyLayout.financialYearStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
    },
  },
  data() {
    return {
      period: [],
      tableData: [],
      moment:moment,

      pickerOptions: {
        shortcuts: [{
          text: 'This month',
          onClick(picker) {
            const end = moment().endOf('month');
            const start = moment().startOf('month');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = moment().endOf('month').subtract(1, 'months');
            const start = moment().startOf('month').subtract(1, 'months');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last 3 months',
          onClick(picker) {
            const end = moment().endOf('month').subtract(1, 'months');
            const start = moment().startOf('month').subtract(3, 'months');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'This financial quarter',
          onClick(picker) {
            const end = moment().endOf('quarter');
            const start = moment().startOf('quarter');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last financial quarter',
          onClick(picker) {
            const end = moment().subtract(1, 'quarter').endOf('quarter');
            const start = moment().subtract(1, 'quarter').startOf('quarter');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'This financial year',
          onClick(picker) {
            const end = moment().endOf('year');
            const start = moment().startOf('year');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last financial year',
          onClick(picker) {
            const end = moment().endOf('year').subtract(1, 'year');
            const start = moment().startOf('year').subtract(1, 'year');
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      currencyList: []
    }
  },
  mounted() {
    this.loadCompanyInfo()
  },
  methods: {
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    // * List
    loadList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/company/worksheet?companyId=${this.$route.query.companyId}&startDate=${moment(this.period[0]).format('MM-DD-YYYY')}&endDate=${moment(this.period[1]).format('MM-DD-YYYY')}`)
        .then(response => {
            this.tableData = response.data.workSheet.map(val => {
              for (let key in val) {
                if (Number(val[key]) === 0) {
                  val[key] = null
                }
              }
              return val
            })
            // for (let i = 0; i < this.tableData.length; i++) {
            //   this.tableData[i].createDate = this.tableData[i].createDate ? moment(this.tableData[i].createDate * 1000).format("D MMM YY") : '';
            // }
            loader.hide()
          this.$refs.table.debouncedUpdateLayout()
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getSummaries(param) {
      const rounded = (number) => {
        return this.formatPrice(+number.toFixed(2));
      }
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            console.log('value', value)
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
        console.log('sums[index]', sums[index])
        if (sums[index] === 0) {
          sums[index] = null
        } else if (sums[index] > 0) {
          sums[index] = rounded(sums[index])
        }
      });

      return sums;
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    // rowClick(row, column, event) {
    //   if (column.label !== 'Action') {
    //     this.row = row
    //     row.docType = 'sop'
    //     this.$refs.DocumentInfo.openModal(row);
    //   }
    // },
    cellClick(row, column, event) {
      if (column.label === 'Accounts List (COA)') {
        // console.log('this.period', this.period)
        // console.log('this.$refs.bankAccountTransactionModal', this.$refs.bankAccountTransactionModal)
        const params = {
          data: {...row, name: row.account, code: '', DRCRCode: '', id: row.accountid }
        }
        this.$refs.generallLedgerDetailedModal.openModal(params);
      }
    },
    loadCompanyInfo() {
      let loader = this.$loading.show();
      axios.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("token");
      axios.defaults.headers.common["X-Timezone-Offset"] = (
          new Date().getTimezoneOffset() / 60
      ).toString();
      axios
          .post(
              `/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=create`
          )
          .then((response) => {
            this.currencyList = response.data.currencyList;
            loader.hide();
            this.$refs.table.debouncedUpdateLayout()
          })
          .catch((error) => {
            console.log("An error occurred:", error);
            loader.hide();
          });
    },
    async exportData (typeExportId, typeId) {
      let email = null
      try {

        if (typeExportId === 3) {
          const { value } = await this.$prompt('Please input your e-mail', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: 'Invalid Email'
          })
          email = value
        }
        const payload = {
          companyId: +this.$route.query.companyId,
          typeId: typeId,
          typeExportId: typeExportId,
          startDate: this.financialYearStartDateFormatted ? this.financialYearStartDateFormatted : '2022-01-01',
          endDate: moment().format('YYYY-MM-DD'),
          email: email,
          optionalField: {
            name: "all",
            value: 'all'
          },
          filterBy: null,
          filterValue: null,
          orderBy: null,
          order: null
        }
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = (
            new Date().getTimezoneOffset() / 60
        ).toString()
        const { data } = await axios.post(`/api/v1/export`, payload)
        switch (typeExportId) {
          case 2: // pdf
          case 1: // xl
            window.open(data.file.downloadPath).focus()
            break
        }
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    }
  },
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  overflow: hidden;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

.file {
  cursor: pointer;
  &__item {
    display: flex;
      &__viewed{
        display:flex;
        align-items:center;
        cursor:pointer;
      }
      &__not-loaded{
        display:flex;
        align-items:center;
      }
  }
  &__name {
    margin-right: 10px;
  }
  &__delete {
    color: red;
    cursor: pointer;
  }
}

/deep/.el-range-separator{
  position:relative;
  &::before{
    color: #C0C4CC;
    font-family: "element-icons";
    position:absolute;
    content: "\E78E";
    left:5px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
